/*
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-16 09:59:59
 */
export default [

    {
        path: "adminList",
        name: "ADMIN_LIST",
        meta: {
            title: "员工列表",
            icon: "",
            isNav: true,
        },
        component: () =>
            import ("@/views/system/adminList.vue"),
    },
    {
        path: "organization",
        name: "SYSTEM_ORGANIZATION",
        meta: {
            title: "组织管理",
            icon: "",
            isNav: true,
        },
        component: () =>
            import ("@/views/system/organization.vue"),
    },
    {
        path: "position",
        name: "SYSTEM_POSITION",
        meta: {
            title: "岗位管理",
            icon: "",
            isNav: true,
        },
        component: () =>
            import ("@/views/system/position.vue"),
    },
    {
        path: "menu",
        name: "SYSTEM_MENU",
        meta: {
            title: "菜单管理",
            icon: "",
            isNav: true,
        },
        component: () =>
            import ("@/views/system/menu.vue"),
    },
    {
        path: "role",
        name: "SYSTEM_ROLE",
        meta: {
            title: "角色管理",
            icon: "",
            isNav: true,
        },
        component: () =>
            import ("@/views/system/role.vue"),
    },
    {
        path: "enums",
        name: "SYSTEM_ENUMS",
        meta: {
            title: "字典管理",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/system/dictionaries.vue"),
    },
    {
        path: "config",
        name: "SYSTEM_CONFIG",
        meta: {
            title: "配置管理",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/system/configuration.vue"),
    },
    {
        path: "versionInformation",
        name: "VERSION_INFOMATION",
        meta: {
            title: "版本信息",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/system/editionList.vue"),
    },
];